import { initials } from '../lib/people'

/**
 * A person beside their name: their photo (AUTH-13), else their initials. It only shows who stands
 * there, so screen readers pass it by and read the name beside it.
 */
export function Avatar({ name, photo, className = 'avatar' }: { name: string; photo?: string | null; className?: string }) {
  if (photo) return <img className={`${className} photo`} src={photo} alt="" loading="lazy" decoding="async" />
  return (
    <span className={className} aria-hidden="true">
      {initials(name)}
    </span>
  )
}
